module.exports = __webpack_public_path__ + "static/uni_silicon-c9fa92d0b882be62f486254b438100b7.png";